<template>
    <div class="row">
      <!--
        maxLength esta seteado al valor máximo que puede tener un entero
        para mitigar la ocurrencia de un error de limite de texto en el componente
        de editor html
      -->
      <LmTextArea
      class="col-12 col-md-12"
      v-model="component.componentProps.html"
      :maxLength=2147483647
      />
      <!-- <LmEditor
        class="col-12 col-md-12"
        :contentProps="component.componentProps.html"
        @onUpdate="component.componentProps.html = unescapeString($event); $emit('input', component)"
        :variablesOptions="[
          { id: 0, name: $t('date'), value: 'date' },
          { id: 1, name: $t('name'), value: 'name' }
        ]"
      /> -->
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="onLabelChange($event)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
      />
      <LmTextInput
        v-if="validateSuperUser"
        class="col-12 col-md-4"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component)"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
    </div>
</template>

<script>
import LmEditor from '@/components/form/elements/lmEditor'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTextArea from '@/components/form/elements/LmTextArea.vue'
import LmSelect from '@/components/form/elements/LmSelect'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      component: {},
      validations: {}
    }
  },
  components: {
    LmEditor,
    LmTextInput,
    LmTextArea,
    LmSelect,
    LmConditionalBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    componentData: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: [String, Number]
    }
  },
  methods: {
    initializeComponent () {
      this.component = this.componentData
    },
    unescapeString (htmlEscapedString) {
      const htmlEntityMap = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'"
      }

      return htmlEscapedString.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, (match) => htmlEntityMap[match])
    }
  },
  created () {
    this.initializeComponent()
  }
}
</script>
